import { supabase } from "@/integrations/supabase/client";

const CHUNK = 150;

/**
 * Task IDs that have at least one `cleaning_task_checklist_assignments` row.
 * When present, cleaner visibility must come from those rows — not from a
 * possibly stale `cleaning_tasks.cleaner_id` left over from legacy flow or
 * from another cleaner starting the job.
 */
export async function getTaskIdsWithChecklistAssignmentRows(taskIds: string[]): Promise<Set<string>> {
  const ids = new Set<string>();
  if (taskIds.length === 0) return ids;
  for (let i = 0; i < taskIds.length; i += CHUNK) {
    const slice = taskIds.slice(i, i + CHUNK);
    const { data, error } = await supabase
      .from("cleaning_task_checklist_assignments")
      .select("cleaning_task_id")
      .in("cleaning_task_id", slice);
    if (error) throw error;
    for (const r of data ?? []) {
      if (r.cleaning_task_id) ids.add(r.cleaning_task_id);
    }
  }
  return ids;
}

export async function taskHasChecklistAssignmentRow(cleaningTaskId: string): Promise<boolean> {
  const s = await getTaskIdsWithChecklistAssignmentRows([cleaningTaskId]);
  return s.has(cleaningTaskId);
}
